module.exports = __webpack_public_path__ + "img/zs_2@2x.2b7b1b7e.png";